import { useEffect } from 'react';
import { Alert } from '@nimbus-ds/components';
import useLayoutScroll from 'App/components/AppLayout/useLayoutScroll';
import useTranslationCatalog from 'domains/Catalog/useTranslationCatalog';

interface InvoiceSettingsErrorProps {
  show: boolean;
  onClose: () => void;
}

function InvoiceSettingsError({
  show,
  onClose,
}: Readonly<InvoiceSettingsErrorProps>): JSX.Element | null {
  const { scrollToTop } = useLayoutScroll();
  const t = useTranslationCatalog('products.detail.invoiceSettings');

  useEffect(() => {
    if (show) scrollToTop();
  }, [show, scrollToTop]);

  return (
    <Alert show={show} appearance="warning" onRemove={onClose}>
      {t('errorInvoiceSettings')}
    </Alert>
  );
}

export default InvoiceSettingsError;
